// removed by extract-text-webpack-plugin
module.exports = {"checkbox":"_3cwHowcRVW0Zc0FLBufMrN","headerCheckbox":"_2kp7GysliaQFmcHYXnPVLA"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/tanksList/styles.css
// module id = 1665
// module chunks = 0